import {
  CREATE_DAEMON,
  DEPLOY_LAMBDA,
  DEPLOYED_LAMBDA_DETAILS,
  GET_ALL_DAEMONS,
  GET_LAMBDAS,
  REFRESH_DAEMON_ACCESS_TOKEN,
  ADD_RUNBOOK_SCRIPT,
  GET_RUNBOOK_SCRIPTS,
  DEPLOY_RUNBOOK_SCRIPT,
  EDIT_RUNBOOK_SCRIPT,
  GET_EXECUTE_RESULTS,
  GET_ALERTS_BASED_ON_RESOURCE,
  MAP_ALERT_TO_LAMBDA,
  DISASSOCIATE_ALERT_FROM_LAMBDA,
  GET_MAPPED_LAMBDA_ALERTS,
  GET_DAEMON_DETAIL,
  GET_ACCOUNT_LAMBDAS,
  GET_AVAILABLE_ROLES, GET_ALL_TOKENS, UPDATE_DAEMON_TOKEN
} from './actionTypes';
import {call, put, takeEvery} from "redux-saga/effects";

import {
  createDaemonSuccess,
  createDaemonFail,
  refreshDaemonAccessTokenFail,
  refreshDaemonAccessTokenSuccess,
  getAllDaemonsFail,
  getAllDaemonsSuccess,
  getLambdasSuccess,
  getLambdasFail,
  deployLambdaFail,
  deployLambdaSuccess,
  deployedLambdaDetailsFail,
  deployedLambdaDetailsSuccess,
  addRunbookScriptSuccess,
  addRunbookScriptFail,
  getRunbookScriptSuccess,
  getRunbookScriptFail,
  deployRunbookScriptSuccess,
  deployRunbookScriptFail,
  editRunbookScriptSuccess,
  editRunbookScriptFail,
  getExecuteResultsSuccess,
  getExecuteResultsFail,
  getAlertsBasedOnResourceSuccess,
  getAlertsBasedOnResourceFail,
  mapAlertToLambdaSuccess,
  mapAlertToLambdaFail,
  disassociateAlertFromLambdaSuccess,
  disassociateAlertFromLambdaFail,
  getMappedLambdaAlertsSuccess,
  getMappedLambdaAlertFail,
  getDaemonDetailSuccess,
  getDaemonDetailFail,
  getAccountLambdasSuccess,
  getAccountLambdasFail,
  getAvailableRolesSuccess,
  getAvailableRolesFail,
  getAllTokensSuccess,
  getAllTokensFail,
  updateDaemonTokenDetailsSuccess,
  updateDaemonTokenDetailsFail,
} from './actions'

import {
  createDaemonUrl,
  getDaemonUrl,
  refreshNewDaemonUrl,
  getLambdasUrl,
  deployLambdaUrl,
  deployLambdaDetailsUrl,
  addOrEditRunbookScriptUrl,
  getRunbookScripts,
  deployRunbookScript,
  getExecuteResultsUrl,
  getAlertsBasedOnResourceUrl,
  postMapAlertToDeployedLambdaUrl,
  postDisassociateAlertFromLambdaUrl,
  getMappedLambdaAlertsUrl,
  getDaemonDetailUrl,
  getAccountLambdasUrl,
  getAvailableRolesUrl, getAllTokensUrl, updateDaemonTokenUrl
} from '../../helpers/fakebackend_helper';

import {showNotification} from '../../components/Common/notification';

function* onCreateDaemon({payload: daemon}) {
  try {
    const response = yield call(createDaemonUrl, daemon);
    yield put(createDaemonSuccess(response));
    showNotification('success', response.message);
    yield put({type: GET_ALL_TOKENS});
  } catch (error) {
    yield put(createDaemonFail(error.message));
    showNotification('error', error.message);
  }
}

function* onRefreshDaemonAccessToken({payload: daemon}) {
  try {
    const response = yield call(refreshNewDaemonUrl, daemon);
    yield put(refreshDaemonAccessTokenSuccess(response));
    showNotification('success', 'DaemonOnboarding access token generated successfully');
    yield put({type: GET_ALL_TOKENS});
  } catch (error) {
    yield put(refreshDaemonAccessTokenFail(error.message));
    showNotification('error', error.message);
  }
}

function* onGetAllDaemons() {
  try {
    const response = yield call(getDaemonUrl);
    yield put(getAllDaemonsSuccess(response));
  } catch (error) {
    yield put(getAllDaemonsFail(error.message));
  }
}

function* onGetExecuteResults({payload: daemon}) {
  try {
    const response = yield call(getExecuteResultsUrl, daemon);
    yield put(getExecuteResultsSuccess(response));
  } catch (error) {
    yield put(getExecuteResultsFail(error.message));
  }
}

function* onGetAllTokens() {
  try {
    const response = yield call(getAllTokensUrl);
    yield put(getAllTokensSuccess(response));
  } catch (error) {
    yield put(getAllTokensFail(error.message));
  }
}

function* onGetLambdas() {
  try {
    const response = yield call(getLambdasUrl);
    yield put(getLambdasSuccess(response));

  } catch (error) {
    yield put(getLambdasFail(error.message));
  }
}

function* onGetAccountLambdas({payload:monitoring_system_id}) {
  try {
    const response = yield call(getAccountLambdasUrl, monitoring_system_id);
    yield put(getAccountLambdasSuccess(response));
  } catch (error) {
    yield put(getAccountLambdasFail(error.message));
  }
}

function* onPostDeployLambda({payload: deployLambda}) {
  try {
    const response = yield call(deployLambdaUrl, deployLambda);
    yield put(deployLambdaSuccess(response));
  } catch (error) {
    yield put(deployLambdaFail(error.message));
  }
}

function* onPostDeployLambdaDetails({payload: deployLambda}) {
  try {
    const response = yield call(deployLambdaDetailsUrl, deployLambda);
    yield put(deployedLambdaDetailsSuccess(response));
  } catch (error) {
    yield put(deployedLambdaDetailsFail(error.message));
  }
}

function* onAddRunbookScript ({payload: script}) {
  try{
    const response = yield call(addOrEditRunbookScriptUrl, script);
    yield put(addRunbookScriptSuccess(response));
    yield put ({type: GET_RUNBOOK_SCRIPTS});
    showNotification('success', response.message);
  } catch (error) {
    yield put(addRunbookScriptFail(error.message));
    showNotification('error', error.message);
  }
}

function* onGetRunbookScripts () {
  try{
    const response = yield call(getRunbookScripts);
    yield put(getRunbookScriptSuccess(response));
  } catch (error) {
    yield put(getRunbookScriptFail(error.message));
  }
}

function* onDeployRunbookScript({payload: data}) {
  try{
    const response = yield call(deployRunbookScript,data);
    yield put(deployRunbookScriptSuccess(response));
    showNotification('success', response.message);
  } catch (error) {
    yield put(deployRunbookScriptFail(error.message));
  }
}

function* onEditRunbookScript({payload: script}) {
  try {
    const response = yield call(addOrEditRunbookScriptUrl, script);
    yield put(editRunbookScriptSuccess(response));
    yield put({type: GET_RUNBOOK_SCRIPTS});
    showNotification('success', response.message);
  } catch (error) {
    yield put(editRunbookScriptFail(error.message));
    showNotification('error', error.message);
  }
}

function* getAlertsBasedOnResource({payload: data}) {
  try {
    const response = yield call(getAlertsBasedOnResourceUrl, data);
    yield put(getAlertsBasedOnResourceSuccess(response));
  } catch (error) {
    yield put(getAlertsBasedOnResourceFail(error.message));
  }
}

function* mapAlertToLambda({payload: data}) {
  try {
    const response = yield call(postMapAlertToDeployedLambdaUrl, data);
    yield put(mapAlertToLambdaSuccess(response));
  } catch (error) {
    yield put(mapAlertToLambdaFail(error.message));
  }
}

function* disassociateAlertFromLambda({payload: data}) {
  try {
    const response = yield call(postDisassociateAlertFromLambdaUrl, data);
    yield put(disassociateAlertFromLambdaSuccess(response));
  } catch (error) {
    yield put(disassociateAlertFromLambdaFail(error.message));
  }
}

function* getMappedLambdaAlerts({payload: data}) {
  try {
    const response = yield call(getMappedLambdaAlertsUrl, data);
    yield put(getMappedLambdaAlertsSuccess(response));
  } catch (error) {
    yield put(getMappedLambdaAlertFail(error))
  }
}

function* getDaemonDetail({payload: data}) {
  try {
    const response = yield call(getDaemonDetailUrl, data);
    yield put(getDaemonDetailSuccess(response));
  } catch (error) {
    yield put(getDaemonDetailFail(error))
  }
}

function* onUpdateDaemonDetail({payload: data}) {
  try {
    const response = yield call(updateDaemonTokenUrl, data);
    yield put(updateDaemonTokenDetailsSuccess(response));
    yield put({type: GET_ALL_TOKENS});
  } catch (error) {
    yield put(updateDaemonTokenDetailsFail(error))
  }
}
function* onGetAvailableRoles() {
  try{
    const response = yield call(getAvailableRolesUrl)
    yield put(getAvailableRolesSuccess(response))
  } catch (error) {
    yield put(getAvailableRolesFail(error.message))
  }
}

function* DaemonSaga() {
  yield takeEvery(CREATE_DAEMON, onCreateDaemon);
  yield takeEvery(REFRESH_DAEMON_ACCESS_TOKEN, onRefreshDaemonAccessToken);
  yield takeEvery(GET_ALL_DAEMONS, onGetAllDaemons);
  yield takeEvery(GET_EXECUTE_RESULTS, onGetExecuteResults)
  yield takeEvery(GET_LAMBDAS, onGetLambdas);
  yield takeEvery(DEPLOY_LAMBDA, onPostDeployLambda);
  yield takeEvery(DEPLOYED_LAMBDA_DETAILS, onPostDeployLambdaDetails);
  yield takeEvery(ADD_RUNBOOK_SCRIPT, onAddRunbookScript)
  yield takeEvery(GET_RUNBOOK_SCRIPTS, onGetRunbookScripts)
  yield takeEvery(DEPLOY_RUNBOOK_SCRIPT, onDeployRunbookScript);
  yield takeEvery(EDIT_RUNBOOK_SCRIPT, onEditRunbookScript);
  yield takeEvery(GET_ALERTS_BASED_ON_RESOURCE, getAlertsBasedOnResource);
  yield takeEvery(MAP_ALERT_TO_LAMBDA, mapAlertToLambda);
  yield takeEvery(DISASSOCIATE_ALERT_FROM_LAMBDA, disassociateAlertFromLambda);
  yield takeEvery(GET_MAPPED_LAMBDA_ALERTS, getMappedLambdaAlerts);
  yield takeEvery(GET_DAEMON_DETAIL, getDaemonDetail);
  yield takeEvery(GET_ACCOUNT_LAMBDAS, onGetAccountLambdas);
  yield takeEvery(GET_AVAILABLE_ROLES, onGetAvailableRoles);
  yield takeEvery(GET_ALL_TOKENS, onGetAllTokens);
  yield takeEvery(UPDATE_DAEMON_TOKEN, onUpdateDaemonDetail);
}

export default DaemonSaga;